/**
 * Whispering Woods Resort – Custom JavaScript
 * Handles: Hero Slider, Amenities Tabs, Testimonials Slider,
 *          Studio Slider, Mobile Nav Toggle, Booking Date Picker,
 *          Video Play, Sticky Nav
 */

(function ($) {
  'use strict';

  // ============================================================
  // Utility: Simple Slider Factory
  // ============================================================
  function createSlider(opts) {
    var slides    = $(opts.slidesSelector);
    var prevBtn   = $(opts.prevSelector);
    var nextBtn   = $(opts.nextSelector);
    var dots      = $(opts.dotsSelector || null);
    var count     = slides.length;
    var current   = 0;
    var autoPlay  = opts.autoPlay || false;
    var interval  = opts.interval || 5000;
    var timer;

    if (count < 2) return;

    function goTo(index) {
      slides.eq(current).removeClass('active').attr('aria-hidden', 'true');
      dots.eq(current).removeClass('active').attr('aria-selected', 'false');

      current = (index + count) % count;

      slides.eq(current).addClass('active').attr('aria-hidden', 'false');
      dots.eq(current).addClass('active').attr('aria-selected', 'true');

      if (opts.onSlide) opts.onSlide(current);
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    nextBtn.on('click', function () {
      next();
      if (autoPlay) resetTimer();
    });

    prevBtn.on('click', function () {
      prev();
      if (autoPlay) resetTimer();
    });

    dots.each(function (i) {
      $(this).on('click', function () {
        goTo(i);
        if (autoPlay) resetTimer();
      });
    });

    function startTimer() {
      timer = setInterval(next, interval);
    }

    function resetTimer() {
      clearInterval(timer);
      startTimer();
    }

    if (autoPlay) startTimer();
  }

  // ============================================================
  // 1. Hero Slider
  // ============================================================
  function initHeroSlider() {
    var slides = $('.ww-hero__slide');
    var count  = slides.length;

    if (count < 2) return;

    createSlider({
      slidesSelector: '.ww-hero__slide',
      prevSelector:   '#ww-hero-prev',
      nextSelector:   '#ww-hero-next',
      autoPlay:       true,
      interval:       5000,
    });
  }

  // ============================================================
  // 2. Amenities Tab Switcher
  // ============================================================
  function initAmenityTabs() {
    var tabs   = $('.ww-amenities__tab-btn');
    var panels = $('.ww-amenities__panel');

    if (!tabs.length) return;

    tabs.on('click', function () {
      var index = $(this).data('tab-index');

      tabs.removeClass('active').attr('aria-selected', 'false');
      panels.removeClass('active');

      $(this).addClass('active').attr('aria-selected', 'true');
      $('#ww-amenity-panel-' + index).addClass('active');
    });

    // Keyboard navigation
    tabs.on('keydown', function (e) {
      var idx = parseInt($(this).data('tab-index'), 10);
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        tabs.eq((idx + 1) % tabs.length).trigger('click').focus();
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        tabs.eq((idx - 1 + tabs.length) % tabs.length).trigger('click').focus();
      }
    });

    // Horizontal scroll indicator arrows (mobile)
    var $scroller  = $('#ww-amenity-tabs');
    var $wrap      = $scroller.closest('.ww-amenities__tabs-wrap');
    var $leftArrow  = $wrap.find('.ww-amenities__tabs-arrow--left');
    var $rightArrow = $wrap.find('.ww-amenities__tabs-arrow--right');

    if ($scroller.length && $wrap.length) {
      var updateArrows = function () {
        var el = $scroller[0];
        var maxScroll = el.scrollWidth - el.clientWidth;
        var canScroll = maxScroll > 1;
        var atStart = el.scrollLeft <= 1;
        var atEnd   = el.scrollLeft >= maxScroll - 1;

        $leftArrow.toggleClass('is-visible', canScroll && !atStart);
        $rightArrow.toggleClass('is-visible', canScroll && !atEnd);
      };

      var scrollBy = function (dir) {
        var el = $scroller[0];
        var amount = Math.max(el.clientWidth * 0.7, 120);
        el.scrollBy({ left: dir * amount, behavior: 'smooth' });
      };

      $leftArrow.on('click',  function () { scrollBy(-1); });
      $rightArrow.on('click', function () { scrollBy(1); });
      $scroller.on('scroll', updateArrows);
      $(window).on('resize.wwAmenityTabs', updateArrows);

      updateArrows();
      // Recompute after fonts/layout settle
      setTimeout(updateArrows, 300);
    }
  }

  // ============================================================
  // 3. Testimonials Slider
  // ============================================================
  function initTestimonialsSlider() {
    var slides = $('.ww-testimonials__slide');
    var dots   = $('.ww-testimonials__dot');
    var count  = slides.length;

    if (count < 2) return;

    var current = 0;

    function goTo(index) {
      slides.eq(current).removeClass('active').attr('aria-hidden', 'true');
      dots.eq(current).removeClass('active').attr('aria-selected', 'false');

      current = (index + count) % count;

      slides.eq(current).addClass('active').attr('aria-hidden', 'false');
      dots.eq(current).addClass('active').attr('aria-selected', 'true');
    }

    $('#ww-test-next').on('click', function () { goTo(current + 1); });
    $('#ww-test-prev').on('click', function () { goTo(current - 1); });

    dots.each(function (i) {
      $(this).on('click', function () { goTo(i); });
    });

    // Swipe support – mobile only (<= 768px)
    var $track = $('#ww-testimonials-slides');
    if (!$track.length) return;

    var SWIPE_THRESHOLD = 40; // px
    var isMobile  = function () { return window.matchMedia('(max-width: 768px)').matches; };
    var startX = 0, startY = 0, deltaX = 0, deltaY = 0, tracking = false;

    $track.on('touchstart', function (e) {
      if (!isMobile()) return;
      var t = e.originalEvent.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      deltaX = 0;
      deltaY = 0;
      tracking = true;
    });

    $track.on('touchmove', function (e) {
      if (!tracking) return;
      var t = e.originalEvent.touches[0];
      deltaX = t.clientX - startX;
      deltaY = t.clientY - startY;
      // If horizontal intent, prevent vertical scroll hijack
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
        e.preventDefault();
      }
    });

    $track.on('touchend touchcancel', function () {
      if (!tracking) return;
      tracking = false;
      if (Math.abs(deltaX) > SWIPE_THRESHOLD && Math.abs(deltaX) > Math.abs(deltaY)) {
        goTo(current + (deltaX < 0 ? 1 : -1));
      }
    });
  }

  // ============================================================
  // 4. Studio Slider
  // ============================================================
  function initStudioSlider() {
    var slides = $('.ww-studio__slide');
    var count  = slides.length;

    if (count < 2) return;

    createSlider({
      slidesSelector: '.ww-studio__slide',
      prevSelector:   '#ww-studio-prev',
      nextSelector:   '#ww-studio-next',
      autoPlay:       false,
    });
  }

  // ============================================================
  // 5. Mobile Nav Toggle
  // ============================================================
  function initMobileNav() {
    var toggle = $('#ww-nav-toggle');
    var menu   = $('#ww-mobile-menu');
    var body   = $('body');

    if (!toggle.length) return;

    toggle.on('click', function () {
      var isOpen = menu.hasClass('open');

      toggle.toggleClass('open').attr('aria-expanded', !isOpen ? 'true' : 'false');
      menu.toggleClass('open');
      body.toggleClass('ww-nav-open');
    });

    // Close on link click
    menu.find('a').on('click', function () {
      toggle.removeClass('open').attr('aria-expanded', 'false');
      menu.removeClass('open');
      body.removeClass('ww-nav-open');
    });

    // Close on Escape key
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && menu.hasClass('open')) {
        toggle.removeClass('open').attr('aria-expanded', 'false');
        menu.removeClass('open');
        body.removeClass('ww-nav-open');
        toggle.focus();
      }
    });
  }

  // ============================================================
  // 6. Booking Widget – Date Picker Constraints
  // ============================================================
  function initBookingDates() {
    var checkin  = $('#ww-checkin');
    var checkout = $('#ww-checkout');
    var checkinLabel  = $('.ww-booking__date-label--checkin');
    var checkoutLabel = $('.ww-booking__date-label--checkout');

    if (!checkin.length) return;

    // Set today as minimum for check-in
    var today = new Date();
    var yyyy  = today.getFullYear();
    var mm    = String(today.getMonth() + 1).padStart(2, '0');
    var dd    = String(today.getDate()).padStart(2, '0');
    var todayStr = yyyy + '-' + mm + '-' + dd;

    checkin.attr('min', todayStr);

    function formatDate(dateStr) {
      var d = new Date(dateStr);
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
    }

    // Click labels to open native date picker
    checkinLabel.on('click', function () {
      checkin[0].showPicker ? checkin[0].showPicker() : checkin[0].focus();
    });
    checkoutLabel.on('click', function () {
      checkout[0].showPicker ? checkout[0].showPicker() : checkout[0].focus();
    });

    // Update label text when date changes
    checkin.on('change', function () {
      var val = $(this).val();
      if (val) {
        checkinLabel.text(formatDate(val));

        var d = new Date(val);
        d.setDate(d.getDate() + 1);
        var outMin = d.getFullYear() + '-'
          + String(d.getMonth() + 1).padStart(2, '0') + '-'
          + String(d.getDate()).padStart(2, '0');
        checkout.attr('min', outMin);

        // If existing checkout is before new min, reset it
        if (checkout.val() && checkout.val() <= val) {
          checkout.val('');
          checkoutLabel.text('Check Out');
        }
      }
    });

    checkout.on('change', function () {
      var val = $(this).val();
      if (val) {
        checkoutLabel.text(formatDate(val));
      }
    });
  }

  // ============================================================
  // 7. Video Section – Play Button
  // ============================================================
  function initVideoSection() {
    var section  = $('#ww-video');
    var playBtn  = $('#ww-video-play');
    var iframeWrap = $('#ww-video-iframe');

    if (!playBtn.length) return;

    playBtn.on('click', function () {
      var videoUrl = playBtn.data('video-url');

      if (videoUrl && iframeWrap.length) {
        // Inject iframe with autoplay
        var embedUrl = videoUrl;
        if (embedUrl.indexOf('youtube.com') > -1 || embedUrl.indexOf('youtu.be') > -1) {
          // Convert to embed URL if needed
          embedUrl = embedUrl.replace('watch?v=', 'embed/').replace('youtu.be/', 'www.youtube.com/embed/');
          if (embedUrl.indexOf('?') > -1) {
            embedUrl += '&autoplay=1&rel=0';
          } else {
            embedUrl += '?autoplay=1&rel=0';
          }
        } else if (embedUrl.indexOf('vimeo.com') > -1) {
          var vimeoId = embedUrl.match(/vimeo\.com\/(\d+)/);
          if (vimeoId) {
            embedUrl = 'https://player.vimeo.com/video/' + vimeoId[1] + '?autoplay=1';
          }
        }

        iframeWrap.html('<iframe src="' + embedUrl + '" allow="autoplay; fullscreen" allowfullscreen></iframe>');
        iframeWrap.addClass('playing');
        playBtn.hide();
      }
    });
  }

  // ============================================================
  // 8. Mega Dropdown – Click Toggle
  // ============================================================
  function initMegaDropdown() {
    var parents = $('.has-mega-dropdown');
    if (!parents.length) return;

    // Toggle on parent link click
    parents.each(function () {
      $(this).children('a').first().on('click', function (e) {
        e.preventDefault();
        var $parent = $(this).parent();
        var wasOpen = $parent.hasClass('is-open');

        // Close all others first
        parents.removeClass('is-open');

        if (!wasOpen) {
          $parent.addClass('is-open');
        }
      });
    });

    // Close when clicking outside the nav
    $(document).on('click', function (e) {
      if (!$(e.target).closest('.has-mega-dropdown').length) {
        parents.removeClass('is-open');
      }
    });

    // Close on Escape key
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') {
        parents.removeClass('is-open');
      }
    });
  }

  // ============================================================
  // 9. Sticky Nav – Add "scrolled" class on scroll + hide/show on direction
  // ============================================================
  function initStickyNav() {
    var nav = $('#ww-header');
    if (!nav.length) return;

    var lastScrollY = 0;
    var scrollThreshold = 60;

    $(window).on('scroll.wwNav', function () {
      var currentScrollY = $(this).scrollTop();

      // Scrolled state (solid background)
      if (currentScrollY > scrollThreshold) {
        nav.addClass('scrolled');
      } else {
        nav.removeClass('scrolled');
        nav.removeClass('nav-hidden');
        lastScrollY = currentScrollY;
        return;
      }

      // Hide on scroll down, show on scroll up
      if (currentScrollY > lastScrollY && currentScrollY > scrollThreshold) {
        nav.addClass('nav-hidden');
      } else {
        nav.removeClass('nav-hidden');
      }

      lastScrollY = currentScrollY;
    });
  }

  // ============================================================
  // Room Hero Slider
  // ============================================================
  function initRoomSlider() {
    var $slider = $('#ww-room-slider');
    if (!$slider.length) return;

    var $slides = $slider.find('.ww-room-hero__slide');
    var $dots   = $('.ww-room-hero__dot');
    var count   = $slides.length;
    if (count <= 1) return;

    var current = 0;

    function goTo(idx) {
      $slides.eq(current).removeClass('active').attr('aria-hidden', 'true');
      $dots.eq(current).removeClass('is-active');

      current = (idx + count) % count;

      $slides.eq(current).addClass('active').attr('aria-hidden', 'false');
      $dots.eq(current).addClass('is-active');
    }

    $('#ww-room-prev').on('click', function () { goTo(current - 1); });
    $('#ww-room-next').on('click', function () { goTo(current + 1); });
    $dots.on('click', function () { goTo($(this).data('index')); });
  }

  // ============================================================
  // Weddings & Events Hero Slider
  // ============================================================
  function initWedHeroSlider() {
    var $slider = $('#ww-wed-slider');
    if (!$slider.length) return;

    var $slides = $slider.find('.ww-wed-hero__slide');
    var $dots   = $('.ww-wed-hero__dot');
    var count   = $slides.length;
    if (count <= 1) return;

    var current = 0;

    function goTo(idx) {
      $slides.eq(current).removeClass('active').attr('aria-hidden', 'true');
      $dots.eq(current).removeClass('is-active');

      current = (idx + count) % count;

      $slides.eq(current).addClass('active').attr('aria-hidden', 'false');
      $dots.eq(current).addClass('is-active');
    }

    $('#ww-wed-prev').on('click', function () { goTo(current - 1); });
    $('#ww-wed-next').on('click', function () { goTo(current + 1); });
    $dots.on('click', function () { goTo($(this).data('index')); });
  }

  // ============================================================
  // Spa Packages Tab Switcher
  // ============================================================
  function initSpaPackageTabs() {
    var tabs   = $('.ww-spa-packages__tab-btn');
    var panels = $('.ww-spa-packages__panel');

    if (!tabs.length) return;

    tabs.on('click', function () {
      var index = $(this).data('tab-index');

      tabs.removeClass('active').attr('aria-selected', 'false');
      panels.removeClass('active');

      $(this).addClass('active').attr('aria-selected', 'true');
      $('#ww-spa-pkg-panel-' + index).addClass('active');
    });

    tabs.on('keydown', function (e) {
      var idx = parseInt($(this).data('tab-index'), 10);
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        tabs.eq((idx + 1) % tabs.length).trigger('click').focus();
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        tabs.eq((idx - 1 + tabs.length) % tabs.length).trigger('click').focus();
      }
    });
  }

  // ============================================================
  // Document Ready
  // ============================================================
  $(document).ready(function () {
    initHeroSlider();
    initAmenityTabs();
    initSpaPackageTabs();
    initTestimonialsSlider();
    initStudioSlider();
    initMobileNav();
    initMegaDropdown();
    initBookingDates();
    initVideoSection();
    initStickyNav();
    initRoomSlider();
    initWedHeroSlider();
  });

})(jQuery);
